const headerData = {
    'menu': [
        {
            'name': 'About',
            'id': 'about'
        },
        {
            'name': 'Team',
            'id': 'team'
        },
        {
            'name': 'Schedule',
            'id': 'schedule'
        },
        {
            'name': 'Talk to us!',
            'id': 'contacts'
        }
    ],
    'btns': [
        {
            'val': 'Follow us on <i class="fab fa-facebook-square"></i>',
            'title': 'Facebook',
            'url': 'https://www.facebook.com/',
            'costumClass': 'col-9 mx-auto ml-3 mb-3 col-md-4 ml-md-auto mr-md-2 col-lg-auto'
        },
        {
            'val': 'Follow us on <i class="fab fa-instagram"></i>',
            'title': 'Instagram',
            'url': 'https://www.instagram.com/',
            'costumClass': 'col-9 mx-auto mr-3 mb-3 col-md-4 mr-md-auto ml-md-2 col-lg-auto'
        }
    ]
}

export default headerData